export const WAITLIST_RESUME_HASH_PARAM = 'resume';

export type ResumedWaitlistForm = {
  sessionId: string;
  breedSlug: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  provinceSlug: string | null;
  citySlug: string | null;
  introMessage: string | null;
};

export function consumeWaitlistResumeToken(): string | null {
  const hash = window.location.hash.replace(/^#/, '');
  if (!hash) return null;
  const params = new URLSearchParams(hash);
  const token = params.get(WAITLIST_RESUME_HASH_PARAM);
  if (!token) return null;
  params.delete(WAITLIST_RESUME_HASH_PARAM);
  const rest = params.toString();
  window.history.replaceState(
    window.history.state,
    '',
    `${window.location.pathname}${window.location.search}${rest ? `#${rest}` : ''}`
  );
  return token;
}

export async function fetchResumedWaitlistForm(
  token: string
): Promise<ResumedWaitlistForm | null> {
  try {
    const response = await fetch(
      '/api/v1.0/public/breed-interests/dropoff/resume',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token })
      }
    );
    if (!response.ok) return null;
    const payload = (await response.json()) as {
      data?: ResumedWaitlistForm;
    };
    return payload.data ?? null;
  } catch {
    return null;
  }
}
